export default {
  generic: {
    success: {
      text: 'Successful',
      type: 'info',
    },
    error: {
      text: 'Oops something went wrong, please try again',
      type: 'warning',
    },
  },
  // Form Errors (vuelidate)
  formValidation: {
    required: (field) => `${field} is required `,
    minLength: (field, number) => `${field} needs to be at least ${number.min} characters`,
    maxLength: (field, number) => `${field} exceeds the ${number.max} character limit for SMS.`,
    minValue: (field) => `${field} cannot be in the past`,
  },
  events: {
    noData: {
      heading: 'No events found',
      message: 'There are no events that match this criteria.',
    },
  },
  records: {
    noData: {
      heading: 'No Records',
      message: 'Generate a webform to start capturing data',
    },
  },
  deliveries: {
    noData: {
      heading: 'No Deliveries',
      message: 'There are currently no deliveries matching this integration',
    },
  },
};
